<template>
    <div
        class="dashboard-channel-card channel-card"
        :class="{
            'selected-element' : selectedChannel=== channel,
            'expanded': expanded
        }"
    >
        <div class="main-info">
            <div class="preview-container">
                <channel-preview
                    v-if="channel.status === 'RUNNING'"
                    :channel="channel"
                    :width="256"
                    :height="144"
                    :default-image="imgUrl"
                ></channel-preview>
                <img v-else class="channel-thumbnail" :src="imgUrl">
            </div>

            <div class="info">
                <div class="card-title">
                    <div>
                        {{ channel.display_name }}
                        <span v-if="fetchingErrorsEncountered === false" class="thin"> | {{ event.name }}</span>
                    </div>
                    <div v-if="channel.status === 'FINISHED'" class="channel-finished">finished</div>
                    <div v-if="channel.status === 'STOPPED'" class="channel-finished">stopped</div>
                </div>
                <!-- TODO figure out what fields is behind 'category' -->
                <div class="info-default">{{schedulingInfoLabel}}</div>
                <div v-if="channel.blanked" class="info-blanked">Blanked</div>
                <div v-if="fetchingErrorsEncountered === false" class="universe">{{ event.universe.display_name }}</div>
                <div class="middle-row" v-if="hasSchedulings">
                    <div class="time">
                        <div class="info-label">START TIME</div>
                        <div>
                            <div class="value">{{ startDateTimeUtc | moment("YYYY.MM.DD") }}</div>
                            <div class="value">{{ startDateTimeUtc | moment("HH:mm") }}<span class="small"> UTC 0</span></div>
                            <div class="value-local">{{ startDateTimeLocal | moment("HH:mm") }}<span class="small"> LOCAL TIME</span></div>
                        </div>
                    </div>
                    <div class="time">
                        <div class="info-label">END TIME</div>
                        <div>
                            <div class="value">{{ endDateTimeUtc | moment("YYYY.MM.DD") }}</div>
                            <div class="value">{{ endDateTimeUtc | moment("HH:mm") }}<span class="small"> UTC 0</span></div>
                            <div class="value-local">{{ endDateTimeLocal | moment("HH:mm") }}<span class="small"> LOCAL TIME</span></div>
                        </div>
                    </div>
                    <div class="duration">
                        <div class="info-label">
                            {{isSchedulingRunning?'REMAINING':'DURATION'}}
                        </div>
                        <div class="value">
                            {{isSchedulingRunning?`${remainingTime}MIN`:duration}}
                        </div>
                    </div>
                </div>
                <div class="middle-row" v-else>
                    <div class="time">
                        <div class="info-label">START TIME</div>
                        <div>
                            <div class="value">{{startTimeUTC}}<span class="small"> UTC 0</span></div>
                            <div class="value-local">{{startTimeLocal}}<span class="small"> LOCAL TIME</span></div>
                        </div>
                    </div>
                    <div class="time">
                        <div class="info-label">END TIME</div>
                        <div>
                            <div class="value">{{ endTimeUtc }}<span class="small"> UTC 0</span></div>
                            <div class="value-local">{{endTimeLocal}}<span class="small"> LOCAL TIME</span></div>
                        </div>
                    </div>
                    <div class="duration">
                        <div class="info-label">DURATION</div>
                        <div class="value">{{ defaultDuration }}</div>
                    </div>
                </div>
                <div
                    v-if="channel.status === 'RUNNING'"
                    class="broadcasting"
                >
                    <img src="/static/image/broadcasting.png">
                    <div>BROADCASTING</div>
                </div>
                <div
                    v-if="channel.confirmed === true && channel.status === 'AVAILABLE' || channel.status === 'PREPARING'"
                    class="broadcasting"
                >
                    <div>CONFIRMED</div>
                </div>
                <div
                    v-if="channel.confirmed === true && channel.status === 'STARTING' || channel.status === 'START_REQUESTED'"
                    class="broadcasting"
                >
                    <div>STARTING</div>
                </div>
                <div
                    v-if="channel.confirmed === true && channel.status === 'STOPPING' || channel.status === 'STOP_REQUESTED'"
                    class="confirmation-pending"
                >
                    <div>STOPPING</div>
                </div>
                <div
                    v-if="!channel.confirmed"
                    class="confirmation-pending"
                >
                    <img src="/static/image/confirmation-pending-icon.svg">confirmation pending
                </div>
            </div>
            <div v-if="channel.status === 'FINISHED'" class="channel-overlay"></div>
        </div>
        <div class="channel-description">
            <span class="channel-description-title">description: </span>
            <div v-if="channel.description">{{ channel.description }}</div>
            <div v-else style="font-style: italic;">no description provided</div>
        </div>
        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : show}"
        ></i>
    </div>
</template>

<script>
import ChannelPreview from '@/components/ChannelAndConfigurationPreview'
import moment from 'moment';
export default {
    components:{
        ChannelPreview
    },
    props: {
        channel:{
            type: Object,
        },
        selectedChannel:{
            type: Object,
        },
        events:{
            type: Array,
        },
        schedulings:{
            type: Array,
            reqiured: true
        },
    },

    data: function(){
        return {
            expanded: true,
            fetchingErrorsEncountered: false,
            defaultPreviewImageUrl: '/static/image/channel-default-picture.jpg',
            remainingTimeInterval: null,
            remainingTime: 0,
        };
    },
    computed:{
        show(){
            if(this.selectedChannel && this.selectedChannel.uid === this.channel.uid) {
                return true;
            }
            return false;
        },
        imgUrl() {
            if (this.channel.thumbnail) {
                return this.channel.thumbnail;
            }
            return this.defaultPreviewImageUrl;
        },
        defaultDuration(){
            let start = moment(this.channel.default_start_time, 'HH:mm:ss');
            let end = moment(this.channel.default_end_time, 'HH:mm:ss');
            // let start = moment('17:00:00', 'HH:mm:ss');
            // let end = moment('17:00:00', 'HH:mm:ss');
            return moment(end.diff(start)).subtract(1, 'hours').format('HH:mm:ss');
        },
        startDateTimeUtc (){
            return  moment.utc(this.nextEndingScheduling.start_date);
        },
        startDateTimeLocal (){
            return  moment.utc(this.nextEndingScheduling.start_date).local();
        },
        endDateTimeUtc (){
            return  moment.utc(this.nextEndingScheduling.end_date);
        },
        endDateTimeLocal (){
            return  moment.utc(this.nextEndingScheduling.end_date).local();
        },
        startTimeUTC (){
            return  moment.utc(this.channel.default_start_time, 'HH:mm').format('HH:mm');
        },
        startTimeLocal (){
            return  moment.utc(this.channel.default_start_time, 'HH:mm').local().format('HH:mm');
        },
        endTimeUtc (){
            return  moment.utc(this.channel.default_end_time, 'HH:mm').format('HH:mm');
        },
        endTimeLocal (){
            return  moment.utc(this.channel.default_end_time, 'HH:mm').local().format('HH:mm');
        },

        event(){
            return this.events.find(event => event.uid === this.channel.event_uid);
        },
        hasSchedulings(){
            if (this.schedulings.length > 0){
                return true;
            }
            return false;
        },
        nextEndingScheduling(){
            if(this.hasSchedulings){
                return this.schedulings[0];
            }
            return null;
        },
        isSchedulingRunning(){
            if(this.nextEndingScheduling && this.nextEndingScheduling.status === 'RUNNING'){
                return true;
            }
            return false;
        },
        schedulingInfoLabel(){
            if(!this.hasSchedulings){
                return 'Default Scheduling'
            }
            if(this.isSchedulingRunning){
                return 'Current Broadcast';
            }
            return 'Next Broadcast';
        },
        duration(){
            let endTime = moment.utc(this.nextEndingScheduling.end_date);
            let startTime = moment.utc(this.nextEndingScheduling.start_date);
            return moment(endTime.diff(startTime)).subtract(1, 'hours').format('HH:mm:ss');
        },
    },
    watch:{
        'channel.status': function(val){
            if(val === 'STARTING'){
                this.getRemainingTime();
                this.setRemainingTimeInterval();
            }
            if(val === 'STOPPING'){
                clearInterval(this.remainingTimeInterval);
            }
        }
    },
    mounted(){
        if(this.isSchedulingRunning){
            this.getRemainingTime();
            this.setRemainingTimeInterval();
        }
    },
    beforeDestroy(){
        clearInterval(this.remainingTimeInterval);
    },
    methods: {
        addNewProgrammation(){
            this.$emit('open-programming-form');
        },
        displayDetails(){
            this.$emit('open-details', this.channel);
        },
        getRemainingTime(){
            let now = moment.utc();
            let endTime = moment.utc(this.nextEndingScheduling.end_date);
            if(endTime > now) {
                this.remainingTime = Math.round(moment.duration(endTime.diff(now)).asMinutes());
            }
            if(this.remainingTime <= 0){
                clearInterval(this.remainingTimeInterval);
                this.remainingTime = 0;
            }

        },
        setRemainingTimeInterval(){
            this.remainingTimeInterval = setInterval(()=>{
                this.getRemainingTime();
            }, 30000);
        }
    }
};
</script>

<style lang="scss">
.manual-pull-style {
    background: linear-gradient(180deg, #111111 -14.18%, rgba(34, 34, 34, 0) 100%);
    padding-left: 30px;
    .manual {
        padding-top: 20px;
        margin-bottom: 20px;
        font-size: 9px;
        font-weight: 900;
        text-transform: uppercase;
    }
    .decryption {
        margin-bottom: 20px;
        .decryption-label {
            font-size: 9px;
            font-weight: normal;
            text-transform: uppercase;
        }
        .decryption-value {
            font-size: 18px;
            font-weight: 900;
            text-transform: uppercase;
        }
    }
    .key {
        .key-label {
            font-size: 9px;
            font-weight: normal;
            text-transform: uppercase;
            margin-bottom: 5px;
        }
        .buttons {
            display: flex;
            align-items: center;
            .decryption-copy, .decryption-see {
                border-radius: 2px;
                border: none;
                background: #BBBBBB;
                width: auto;
                height: 20px;
                padding: 2px 4px 4px;
                img, i {
                    margin-right: 5px;
                }
                span {
                    display: block;
                    font-size: 9px;
                    line-height: 9px;
                    color: #444444;
                }
            }
            .decryption-copy {
                span {
                    display: flex;
                    align-items: center;
                    .copy-icon {
                        background: url('/static/image/copy.svg') no-repeat;
                        margin-top: 2px;
                        height: 12px;
                        width: 15px;
                        display: block;
                    }
                }
                &:hover {
                    span {
                        .copy-icon {
                            background: url('/static/image/white-copy.svg') no-repeat;
                        }
                        color: #FFFFFF;
                    }
                    background: #00A3FF;
                }
            }
        }
        .decryption-see:hover {
            background: #00A3FF;
            span {
                color: white;
            }
        }
    }
}
@font-face {
    font-family: "roboto";
    src: url("/static/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
    font-family: "roboto-thin";
    src: url("/static/fonts/Roboto-Thin.ttf") format("truetype");
}
@font-face {
    font-family: "roboto";
    src: url("/static/fonts/Roboto-Black.ttf") format("truetype");
    font-weight: bold;
}

@font-face {
    font-family: "roboto-light";
    src: url("/static/fonts/Roboto-Light.ttf") format("truetype");
}

.channel-thumbnail{
    width: 256px;
    height: 144px;
}
div.channel-thumbnail{
    background: #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    font-size: 14px !important;
    text-align: center;
    i{
        font-size: 40px;
    }
}
.dashboard-channel-card{
    height: 111px;
    padding: 15px !important;
    &.expanded{
        height: auto;
        flex-direction: column;
    }
    // .gcmcn-player{
    //     width: 105px !important;
    // }
    // .gcmcn-player, .channel-thumbnail{
    //     max-height: 59px !important;
    // }
    .main-info {
        justify-content: space-between;
        .info {
            padding: 0 15px !important;
            min-height: auto;
            .card-title {
                font-size: 12px !important;
                line-height: 12px !important;
            }
            .middle-row {
                .value {
                    font-size: 12px !important;
                }
            }
        }
    }
}

.channel-card {
    .channel-description{
        .channel-description-title{
            font-weight: bold;
            color: #fff;
        }
        font-size: 11px;
        margin-top: 5px;
        word-break: break-word;
        text-transform: uppercase;
        div{
            display: inline;
        }
    }
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    background-color: #222223;
    padding: 20px;
    font-family: "roboto";
    color: #BBBBBB;
    border-radius: 5px;
    height: auto;
    transition: height ease-in-out .3s;
    position: relative;

    // .gcmcn-player{
    //     width: 225px;
    // }
    .channel-overlay{
        max-width: 800px;
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        width: 100%;
        height: 100%;
        background-color: rgba(32,32,32,.5);
    }
    .broadcasting{
        color: #28E37C;
        font-size: 9px;
        display: flex;
        padding-top: 1em;
        img{
            margin-right: 5px;
        }
    }
    .confirmation-pending {
        font-size: 9px;
        color: #FFDC42;
        text-transform: uppercase;
        padding-top: 1em;
        img {
            margin-right: 5px;
        }
    }
    .main-info {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .preview-container {
            width: fit-content;
            // .channel-thumbnail {
            //     height: 120px;
            //     max-width: 225px;
            // }
        }
    }
    .info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 0 30px;
        min-height: 120px;
        height: auto;
        max-width: 494px;
        .card-title {
            width: 100%;
            font-size: 18px;
            font-family: 'roboto';
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            text-transform: uppercase;
            .thin {
                font-family: "roboto-light";
                font-weight: normal;
            }
            .channel-finished{
                font-size: 9px;
                text-transform: uppercase;
                font-family: roboto;
            }
        }
        .universe {
            width: 100%;
            font-size: 9px;
            font-family: "roboto";
            font-weight: normal;
            text-transform: uppercase;
            margin-bottom: 10px;
        }
        .middle-row {
            display: flex;
            justify-content: space-between;
            .info-label {
                font-size: 9px;
                text-transform: uppercase;
            }
            .value {
                font-size: 17px;
                text-transform: uppercase;
                font-family: 'roboto';
                font-weight: bold;
                // padding-right: 0.2em;
                .small {
                    font-family: 'roboto';
                    font-size: 9px;
                    font-weight: normal;
                }
            }
            .value-local {
                font-size: 10px;
                text-transform: uppercase;
                font-family: 'roboto';
                font-weight: bold;
                .small {
                    font-size: 9px;
                    font-family: 'roboto';
                    font-weight: normal;
                }
            }
        }
        .more {
            display: flex;
            align-items: center;
            font-size: 9px;
            width: 100%;
            text-transform: uppercase;
            .el-button {
                margin-left: 10px;
                color: #BBBBBB;
                padding: 0;
            }
        }
    }
    .button-container {
        margin-right: 20px;
    }
    &+.channel-card {
        margin-top: 20px;
    }
}
.channel-card + .channel-card{
    margin-top: 20px;
}


@media screen and (max-width: 1025px) {
    .dashboard-channel-card{
        // height: 103px;
        padding: 10px !important;
        &.expanded{
            height: auto;
        }
        .broadcasting, .confirmation-pending {
            margin-top: 15px;
            word-break: break-word;
            text-align: center;
        }
        // .gcmcn-player{
        //     max-width: 79px !important;
        // }
        // .gcmcn-player, .channel-thumbnail{
        //     max-height: 53px !important;
        // }
        .main-info {
            .info {
                padding: 0 10px !important;
            }
        }
    }
}
.work-order-display {
    padding-bottom: 0.5em;
    display: inline;
}
.info-default{
    margin-top: 1em;
    font-size: 10px;
    text-transform: uppercase;
}
.info-blanked{
    margin-top: 1em;
    font-size: 10px;
    text-transform: uppercase;
    color: #FBBC4E;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/channels-card.vue